import { Controller } from "stimulus"

// Recarga la página mientras un proceso en background sigue corriendo, para
// que el resultado aparezca sin tener que actualizar a mano.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timeout = setTimeout(() => window.location.reload(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
